// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__1vF5U","item":"styles_item__3zhUi","itemText":"styles_itemText__1XuOk","noIcon":"styles_noIcon__2M2q5","active":"styles_active__2yZKx"};